export const TRANSCRIPT_URLS = {
  1: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-1.json',
  2: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-2.json',
  3: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-3.json',
  4: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-4.json',
  5: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-5.json',
  6: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-6.json',
  7: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/transcripts/transcript-1-7.json',
};

export const NOTES_URLS = {
  1: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-1.md',
  2: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-2.md',
  3: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-3.md',
  4: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-4.md',
  5: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-5.md',
  6: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-6.md',
  7: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-1-7.md',
  8: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-8.md',
  9: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-9.md',
  10: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-10.md',
  11: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-11.md',
  12: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-12.md',
  13: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-13.md',
  14: 'https://raw.githubusercontent.com/fastai/course-v3/master/files/dl-2019/notes/notes-2-14.md',
}
 
export const VIDEO_SOURCES = {
  1: "XfoYk_Z5AkI",
  2: "ccMHJeQU4Qw",
  3: "MpZxV6DVsmM",
  4: "qqt3aMPB81c",
  5: "CJKnDu2dxOE",
  6: "hkBa9pU-H48",
  7: "9spwoDYwW_I",
  8:  "4u8FxNEDUeg",
  9:  "AcA8HAYh7IE",
  10: "HR0lt1hlR6U",
  11: "hPQKzsjTyyQ",
  12: "vnOpEwmtFJ8",
  13: "3TqN_M1L4ts",
  14: "8wd8zFzTG38",
};

export const LESSONS_NAMES = [{
  1: 'Lesson 1',
  2: 'Lesson 2',
  3: 'Lesson 3',
  4: 'Lesson 4',
  5: 'Lesson 5',
  6: 'Lesson 6',
  7: 'Lesson 7',
  8: 'Go to part 2',
}, {
  8:  'Lesson 8',
  9:  'Lesson 9',
  10: 'Lesson 10',
  11: 'Lesson 11',
  12: 'Lesson 12',
  13: 'Lesson 13',
  14: 'Lesson 14',
  1: 'Go to part 1',
}]

export const quickLinks = [
  { title: 'FastAI API Docs', href: 'https://docs.fast.ai/' },
  { title: 'FastAI Course Home', href: 'https://course.fast.ai/' },
]
